"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _Grid = require("../Grid/Grid");
var _PropertyCardActionArea = require("../PropertyCardActionArea/PropertyCardActionArea");
var _PropertyCardBadge = require("../PropertyCardBadge/PropertyCardBadge");
var _PropertyCardBadgeArea = require("../PropertyCardBadgeArea/PropertyCardBadgeArea");
var _PropertyCardBody = require("../PropertyCardBody/PropertyCardBody");
var _PropertyCardDataArea = require("../PropertyCardDataArea/PropertyCardDataArea");
var _PropertyCardDataWrapper = require("../PropertyCardDataWrapper/PropertyCardDataWrapper");
var _PropertyCardFlexWrapper = require("../PropertyCardFlexWrapper/PropertyCardFlexWrapper");
var _PropertyCardHomeDetails = require("../PropertyCardHomeDetails/PropertyCardHomeDetails");
var _PropertyCardHomeDetailsList = require("../PropertyCardHomeDetailsList/PropertyCardHomeDetailsList");
var _PropertyCardMenuPopper = require("../PropertyCardMenuPopper/PropertyCardMenuPopper");
var _PropertyCardMLSFooter = require("../PropertyCardMLSFooter/PropertyCardMLSFooter");
var _PropertyCardMLSLogo = require("../PropertyCardMLSLogo/PropertyCardMLSLogo");
var _PropertyCardPhoto = require("../PropertyCardPhoto/PropertyCardPhoto");
var _PropertyCardPhotoBody = require("../PropertyCardPhotoBody/PropertyCardPhotoBody");
var _PropertyCardPhotoFallback = require("../PropertyCardPhotoFallback/PropertyCardPhotoFallback");
var _PropertyCardPhotoFooter = require("../PropertyCardPhotoFooter/PropertyCardPhotoFooter");
var _PropertyCardPhotoHeader = require("../PropertyCardPhotoHeader/PropertyCardPhotoHeader");
var _PropertyCardPhotoWrapper = require("../PropertyCardPhotoWrapper/PropertyCardPhotoWrapper");
var _PropertyCardSaveArea = require("../PropertyCardSaveArea/PropertyCardSaveArea");
var _PropertyCardSaveButton = require("../PropertyCardSaveButton/PropertyCardSaveButton");
var _PropertyCard = require("./PropertyCard.context");
var _PropertyCard2 = require("./PropertyCard.styles");
var _excluded = ["aria-label", "actionButton", "appearance", "badge", "cardElevation", "cardGridTemplate", "data", "flexArea", "loading", "onClick", "photoBody", "photoFooter", "photoOrientation", "renderLayout", "renderLoadingLayout", "saveButton"];
/**
 * @extends Card
 * @related ['Carousel', 'PhotoCarousel']
 * @subcomponents ['PropertyCard.Badge', 'PropertyCard.DataArea', 'PropertyCard.HomeDetails',
 * 'PropertyCard.Photo', 'PropertyCard.PhotoFallback', 'PhotoCarousel']
 * @since 8.63.0
 */
var PropertyCard = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _data$mls2, _data$mls3, _data$mls4;
  var ariaLabel = props['aria-label'],
    actionButton = props.actionButton,
    appearance = props.appearance,
    badge = props.badge,
    cardElevation = props.cardElevation,
    cardGridTemplate = props.cardGridTemplate,
    data = props.data,
    flexArea = props.flexArea,
    loading = props.loading,
    onClick = props.onClick,
    photoBody = props.photoBody,
    photoFooter = props.photoFooter,
    photoOrientation = props.photoOrientation,
    renderLayout = props.renderLayout,
    renderLoadingLayout = props.renderLoadingLayout,
    saveButton = props.saveButton,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var getDataAreaProps = function getDataAreaProps(dataType) {
    var _data$dataType;
    var dataAreaObj = {};
    // if value is a props obj
    if ((_data$dataType = data[dataType]) !== null && _data$dataType !== void 0 && _data$dataType.children) {
      dataAreaObj = data[dataType];
    }
    // else it's a string, element or other type of node
    else {
      dataAreaObj = {
        children: data[dataType]
      };
    }
    // if Large card, attach body3 to the end of body1
    if (dataType === 'body1' && props.appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE && data.body3) {
      var body1Children = dataAreaObj.children;
      var body3Children = data.body3.children || data.body3;
      dataAreaObj.children = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, body1Children, /*#__PURE__*/_react.default.createElement("span", null, body3Children));
    }
    return dataAreaObj;
  };
  var additionalInfoArea = function additionalInfoArea() {
    var _data$mls;
    var additionalInfoProps = Object.assign({}, getDataAreaProps('additionalInfo'));
    var mlsAttribution = ((_data$mls = data.mls) === null || _data$mls === void 0 ? void 0 : _data$mls.attribution) || '';
    var separator = additionalInfoProps.children && mlsAttribution ? '. ' : '';
    if (typeof additionalInfoProps.children === 'undefined' && mlsAttribution === '') {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, (0, _extends2.default)({
      dataType: "additionalInfo",
      lineClamp: "none"
    }, additionalInfoProps), additionalInfoProps.children, separator, mlsAttribution);
  };
  var mlsLogo = (_data$mls2 = data.mls) !== null && _data$mls2 !== void 0 && _data$mls2.logoSrc ? /*#__PURE__*/_react.default.createElement(_PropertyCardMLSLogo.PropertyCardMLSLogo, {
    logoSrc: (_data$mls3 = data.mls) === null || _data$mls3 === void 0 ? void 0 : _data$mls3.logoSrc,
    attribution: (_data$mls4 = data.mls) === null || _data$mls4 === void 0 ? void 0 : _data$mls4.attribution
  }) : null;
  var defaultLayout = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_PropertyCardBody.PropertyCardBody, {
    "aria-label": ariaLabel,
    cardElevation: cardElevation,
    interactive: onClick ? true : undefined,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_PropertyCardDataWrapper.PropertyCardDataWrapper, null, /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, (0, _extends2.default)({
    dataType: "title"
  }, getDataAreaProps('title'))), /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, (0, _extends2.default)({
    dataType: "body1"
  }, getDataAreaProps('body1'))), /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, (0, _extends2.default)({
    dataType: "body2"
  }, getDataAreaProps('body2'))), data.body3 && appearance !== _constants.PROPERTY_CARD_APPEARANCES.LARGE && /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, (0, _extends2.default)({
    dataType: "body3"
  }, getDataAreaProps('body3'))), (appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE || appearance === _constants.PROPERTY_CARD_APPEARANCES.FLAG) && additionalInfoArea(), /*#__PURE__*/_react.default.createElement(_PropertyCardActionArea.PropertyCardActionArea, null, actionButton), appearance === _constants.PROPERTY_CARD_APPEARANCES.HORIZONTAL && mlsLogo), /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoWrapper.PropertyCardPhotoWrapper, null, /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoHeader.PropertyCardPhotoHeader, null, /*#__PURE__*/_react.default.createElement(_PropertyCardBadgeArea.PropertyCardBadgeArea, null, badge), /*#__PURE__*/_react.default.createElement(_PropertyCardSaveArea.PropertyCardSaveArea, null, saveButton)), /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoBody.PropertyCardPhotoBody, null, photoBody), /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoFooter.PropertyCardPhotoFooter, null, photoFooter || appearance !== _constants.PROPERTY_CARD_APPEARANCES.HORIZONTAL && mlsLogo)), flexArea && /*#__PURE__*/_react.default.createElement(_PropertyCardFlexWrapper.PropertyCardFlexWrapper, null, flexArea)), (appearance === _constants.PROPERTY_CARD_APPEARANCES.SMALL || appearance === _constants.PROPERTY_CARD_APPEARANCES.HORIZONTAL) && /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
    display: "inline-grid"
  }, additionalInfoArea()));
  var defaultLoadingLayout = /*#__PURE__*/_react.default.createElement(_PropertyCardBody.PropertyCardBody, {
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react.default.createElement(_PropertyCardDataWrapper.PropertyCardDataWrapper, null, /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, {
    dataType: "title"
  }, "\xA0"), /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, {
    dataType: "body1"
  }, "\xA0"), /*#__PURE__*/_react.default.createElement(_PropertyCardDataArea.PropertyCardDataArea, {
    dataType: "body2"
  }, "\xA0")), /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoWrapper.PropertyCardPhotoWrapper, null, /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoBody.PropertyCardPhotoBody, null)));
  var layoutSection = defaultLayout;
  if (!loading && typeof renderLayout === 'function') {
    layoutSection = renderLayout(props);
  }
  if (loading && typeof renderLoadingLayout === 'function') {
    layoutSection = renderLoadingLayout(props);
  }
  if (loading && typeof renderLoadingLayout !== 'function') {
    layoutSection = defaultLoadingLayout;
  }
  return /*#__PURE__*/_react.default.createElement(_PropertyCard.PropertyCardProvider, {
    value: {
      appearance: appearance,
      loading: loading,
      onClick: onClick
    }
  }, /*#__PURE__*/_react.default.createElement(_PropertyCard2.StyledPropertyCard, (0, _extends2.default)({
    ref: forwardedRef,
    appearance: appearance,
    cardElevation: cardElevation,
    cardGridTemplate: cardGridTemplate,
    interactive: onClick ? true : undefined,
    loading: loading,
    photoOrientation: photoOrientation
    // Override interactive `Card` where role="button".
    // (buttons and links can't live inside of a button)
    ,
    role: undefined
  }, rest), layoutSection));
});
exports.PropertyCard = PropertyCard;
PropertyCard.displayName = 'PropertyCard';
PropertyCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Displays a button in the top right of the data area. Usually a
   * `PropertyCard.SaveButton` or `PropertyCard.MenuPopper`.
   *
   * Cannot be used in a Flag card.
   */
  'actionButton': _propTypes.default.node,
  /**
   * Determines the overall card style.
   */
  'appearance': _propTypes.default.oneOf(Object.values(_constants.PROPERTY_CARD_APPEARANCES)),
  /**
   * This is the text that screen readers announce when this card receives focus.
   * Usually, you'll want to use the address of the property. If no `aria-label` is
   * provided, all data area text is announced.
   */
  'aria-label': _propTypes.default.string,
  /**
   * Takes a `PropertyCard.Badge` node that will display in the upper-left corner
   * of the photo container.
   *
   * Note that only a Large Card supports displaying a `PropertyCard.Badge` and
   * `PropertyCard.SaveButton` at the same time.
   */
  'badge': _propTypes.default.node,
  /**
   * This integer determines whether we use a shadow/elevation (1) or no elevation (0).
   */
  'cardElevation': _propTypes.default.oneOf([0, 1]),
  /**
   * Sets the heights or widths of the photo, data and flex wrappers (in that order).
   *
   * Applied using `grid-template-rows` or `grid-template-columns`, depending on the
   * card appearance.
   *
   * If undefined, default values are provided by the theme.
   *
   * Ex: a Large Card by default is set to "149px 1fr auto" which sets
   * the heights of the photo area to 149px, the data area to 1fr and
   * the Flex area (if it exists) to "auto".
   */
  'cardGridTemplate': _propTypes.default.string,
  /**
   * The property info text you’d like to display in the card.
   *
   * The `data` object takes up to five data area properties. which will appear in this order
   * by default: title, body1, body2, body3, additionalInfo.
   *
   * Each data area property can take a node or a props object. Nodes (including strings) will be
   * rendered as children of a `PropertyCard.DataArea`. A props object will be spread
   * across a `PropertyCard.DataArea` (a `children` value is required).
   *
   * An additional property called `mls` is used to display the logo and
   * attribution text for an MLS.
   */
  'data': _propTypes.default.shape({
    title: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
    body1: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
    body2: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
    body3: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
    additionalInfo: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.object]),
    mls: _propTypes.default.shape({
      attribution: _propTypes.default.string,
      logoSrc: _propTypes.default.string
    })
  }),
  /**
   * Custom content that appears after the data areas.
   */
  'flexArea': _propTypes.default.node,
  /**
   * If true, displays the card in a loading state.
   */
  'loading': _propTypes.default.bool,
  /**
   * Executed when you click anywhere on the card (unless you've clicked on an
   * interactive child component) or hit ENTER or SPACE while card has focus.
   */
  'onClick': _propTypes.default.func,
  /**
   * Takes a node that will render across the entire width and height of the photo area.
   * Usually, this will be a `PropertyCard.Photo` or a `PhotoCarousel`.
   */
  'photoBody': _propTypes.default.node,
  /**
   * Takes a node that will override the default photo area footer, `PropertyCard.MLSLogo`.
   */
  'photoFooter': _propTypes.default.node,
  /**
   * Render function that can be used to customize the layout of the page. Receives `props`
   * as an argument.
   */
  'renderLayout': _propTypes.default.func,
  /**
   * Render function that can be used to customize the loading state layout. Receives `props`
   * as an argument.
   */
  'renderLoadingLayout': _propTypes.default.func,
  /**
   * Displays a button in the top right of the photo area. Usually a
   * `PropertyCard.SaveButton`.
   *
   * Note that only a Large Card supports displaying a `PropertyCard.Badge` and
   * `PropertyCard.SaveButton` at the same time.
   */
  'saveButton': _propTypes.default.node
} : {};
PropertyCard.defaultProps = {
  'aria-label': '',
  'appearance': _constants.PROPERTY_CARD_APPEARANCES.LARGE,
  'cardElevation': 1,
  'loading': false
};
PropertyCard.ActionArea = _PropertyCardActionArea.PropertyCardActionArea;
PropertyCard.Badge = _PropertyCardBadge.PropertyCardBadge;
PropertyCard.BadgeArea = _PropertyCardBadgeArea.PropertyCardBadgeArea;
PropertyCard.Body = _PropertyCardBody.PropertyCardBody;
PropertyCard.DataArea = _PropertyCardDataArea.PropertyCardDataArea;
PropertyCard.DataWrapper = _PropertyCardDataWrapper.PropertyCardDataWrapper;
PropertyCard.FlexWrapper = _PropertyCardFlexWrapper.PropertyCardFlexWrapper;
PropertyCard.HomeDetails = _PropertyCardHomeDetails.PropertyCardHomeDetails;
PropertyCard.HomeDetailsList = _PropertyCardHomeDetailsList.PropertyCardHomeDetailsList;
PropertyCard.MenuPopper = _PropertyCardMenuPopper.PropertyCardMenuPopper;
PropertyCard.MLSFooter = _PropertyCardMLSFooter.PropertyCardMLSFooter;
PropertyCard.MLSLogo = _PropertyCardMLSLogo.PropertyCardMLSLogo;
PropertyCard.Photo = _PropertyCardPhoto.PropertyCardPhoto;
PropertyCard.PhotoBody = _PropertyCardPhotoBody.PropertyCardPhotoBody;
PropertyCard.PhotoFallback = _PropertyCardPhotoFallback.PropertyCardPhotoFallback;
PropertyCard.PhotoFooter = _PropertyCardPhotoFooter.PropertyCardPhotoFooter;
PropertyCard.PhotoHeader = _PropertyCardPhotoHeader.PropertyCardPhotoHeader;
PropertyCard.PhotoWrapper = _PropertyCardPhotoWrapper.PropertyCardPhotoWrapper;
PropertyCard.SaveArea = _PropertyCardSaveArea.PropertyCardSaveArea;
PropertyCard.SaveButton = _PropertyCardSaveButton.PropertyCardSaveButton;